import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import ACL_RELATIONSHIPS from "acl-relationships";
import { Button } from "@/components/ui/button";
import Authorized from "components/Authorized";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import CustomFieldService from "services/CustomField";
import {
  invalidateCustomFieldConfigsQuery,
  useCustomFieldConfigTable,
} from "hooks/useCustomFieldConfigTable";

export const CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS = {
  tableName: "custom_field_configs",
  queryKey: "custom-field-configs",
  exportTableName: "CustomFieldConfigTable",
  className: "CustomFieldConfig",
  header: "Custom Field Configs",
  headerIcon: "plus",
};

const CREATE_ACLS = [ACL_RELATIONSHIPS.customFieldConfig.create];

const CustomFieldConfigTableV3 = () => {
  const navigate = useNavigate();
  const { columns, filters } = useCustomFieldConfigTable();

  const fetchCustomFieldConfigs = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await CustomFieldService.getCustomFieldConfigsTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching custom field configs:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      className={CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS.className}
      headerIcon={CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS.headerIcon}
      header={CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS.header}
      queryKey={CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS.queryKey}
      exportTableName={CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS.exportTableName}
      tableName={CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS.tableName}
      createButton={
        <Authorized permissions={CREATE_ACLS}>
          <Button
            size="sm"
            className="item-adder"
            onClick={() => navigate("/settings/custom_field_configs/new")}
          >
            New Custom Field
          </Button>
        </Authorized>
      }
      fetchData={fetchCustomFieldConfigs}
      invalidateData={invalidateCustomFieldConfigsQuery}
      enableSettings
      enableSearch
    />
  );
};

export default CustomFieldConfigTableV3;
